module.exports = __webpack_public_path__ + "img/step9.8232537c.png";